/*=========================================================================================
  File Name: moduleAuthState.js
  Description: Auth Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  isUserLoggedIn: () => {
    return (
      localStorage.getItem('userInfo') !== null &&
            localStorage.getItem('accessToken') !== null
    )
  },
  userDetails: () => {
    return JSON.parse(localStorage.getItem('userInfo'))
  },
  state: { token: localStorage.getItem('accessToken') || null },
  getters: {
    loggedIn (state) {
      console.log(state)
      return state.token !== null
    }
  }
}
